import React from 'react';
import useProduct from '../CustomHook/useProduct';
import InventoryItems from '../InventoryItems/InventoryItems';
import slider1 from '../Slider_img/slider1.jpg'
import slider2 from '../Slider_img/slider2.jpg'
import slider3 from '../Slider_img/slider3.jpg'
import l1 from '../Slider_img/laptop1.jpg'
import l2 from '../Slider_img/laptop2.jpg'
import l3 from '../Slider_img/laptop3.jpg'
import l4 from '../Slider_img/laptop4.jpg'
import l5 from '../Slider_img/laptop5.jpg'
import l6 from '../Slider_img/laptop6.jpg'
import { Link } from 'react-router-dom';
import Iframe from 'react-iframe';
import { Spinner } from 'react-bootstrap';

const Slider = () => {
    const [products] = useProduct();
    const itemProducts = products.slice(0, 6);
    return (
        <div>
            <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img style={{ height: '550px' }} src={slider2} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                        <img style={{ height: '550px' }} src={slider1} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                        <img style={{ height: '550px' }} src={slider3} class="d-block w-100" alt="..." />
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>


            <h3 className='mt-4 mb-3'>Inventory Items</h3>
            <div className="row container-fluid mt-2 ">
                {
                    itemProducts.length === 0 ? <p><Spinner animation="border" role="status">
                        <span className="visually-hidden text-success">Loading...</span>
                    </Spinner></p> : itemProducts.map(product => <InventoryItems key={product._id} product={product}></InventoryItems>)

                }

                <div className="text-center">
                    <button className='btn btn-success w-25 '>
                        <Link style={{ textDecoration: 'none' }} className='text-white' to='/manageinvemtory'>Manage Inventory</Link>
                    </button>
                </div>

            </div>

            <h3 className='mt-4 mb-3'>Laptop Gallary</h3>
            <div className="row container-fluid">
                <div className="col-md-3">
                    <div class="shadow p-2 mb-3 bg-body rounded">
                        <img className='w-100' style={{ height: '200px' }} src={l1} alt="" />
                    </div>
                </div>
                <div className="col-md-3">
                    <div class="shadow p-2 mb-3 bg-body rounded">
                        <img className='w-100' style={{ height: '200px' }} src={l2} alt="" />
                    </div>
                </div>
                <div className="col-md-3">
                    <div class="shadow p-2 mb-3 bg-body rounded">
                        <img className='w-100' style={{ height: '200px' }} src={l3} alt="" />
                    </div>
                </div>
                <div className="col-md-3">
                    <div class="shadow p-2 mb-3 bg-body rounded">
                        <img className='w-100' style={{ height: '200px' }} src={l4} alt="" />
                    </div>
                </div>
            </div>
            <div className="row container-fluid">
                <div className="col-md-3">
                    <div class="shadow p-2 mb-3 bg-body rounded">
                        <img className='w-100' style={{ height: '200px' }} src={l6} alt="" />
                    </div>
                </div>
                <div className="col-md-3">
                    <div class="shadow p-2 mb-3 bg-body rounded">
                        <img className='w-100' style={{ height: '200px' }} src={l5} alt="" />
                    </div>
                </div>
                <div className="col-md-3">
                    <div class="shadow p-2 mb-3 bg-body rounded">
                        <img className='w-100' style={{ height: '200px' }} src={l3} alt="" />
                    </div>
                </div>
                <div className="col-md-3">
                    <div class="shadow p-2 mb-3 bg-body rounded">
                        <img className='w-100' style={{ height: '200px' }} src={l4} alt="" />
                    </div>
                </div>
            </div>


            {/* Extra Itmes======================== */}
            <h3>Laptop Videos</h3>
            <div className="row container-fluid ">
                <div className="col-md-4 shadow-lg p-2">
                    <Iframe url="https://www.youtube.com/embed/Z2MyXuHstIs"
                        width="100%"
                        height="300px"
                        id="myId"
                        className="myClassname"
                        display="initial"
                        position="relative" />
                </div>
                <div className="col-md-4 shadow-lg p-2 ">
                    <Iframe url="https://www.youtube.com/embed/kYFnAnmwG5c"
                        width="100%"
                        height="300px"
                        id="myId"
                        className="myClassname"
                        display="initial"
                        position="relative" />
                </div>
                <div className="col-md-4 shadow-lg p-2">
                    <Iframe url="https://www.youtube.com/embed/V-MksplvAU4"
                        width="100%"
                        height="300px"
                        id="myId"
                        className="myClassname"
                        display="initial"
                        position="relative" />
                </div>
            </div>



            {/* footer============================== */}

            <div style={{ height: '80px' }} className="row mt-5 bg-dark text-white" >
                <p className='mt-4'>@Copyright Laptop-bazar</p>
            </div>
            {/* footer============================== */}
        </div >
    );
};

export default Slider;